import { useAuth } from "@/context/AuthContext";
import { Lock, Sparkles, ArrowRight, Key } from "lucide-react";
import { Link } from "react-router-dom";

const Paywall = ({ feature }) => {
  const { access } = useAuth();
  const expired = access?.status === "trial_expired" || access?.status === "locked";
  return (
    <div className="max-w-xl mx-auto px-6 py-16 text-center" data-testid="paywall">
      <div className="w-16 h-16 rounded-full bg-amber-500/15 border border-amber-500/30 flex items-center justify-center mx-auto mb-6">
        <Lock className="w-7 h-7 text-amber-400" />
      </div>
      <div className="overline mb-2">{expired ? "TRIAL EXPIRED" : "PREMIUM FEATURE"}</div>
      <h1 className="font-serif text-4xl sm:text-5xl mb-4 leading-tight">
        {feature || "This section"} is <span className="italic text-amber-500">premium.</span>
      </h1>
      <p className="text-neutral-400 mb-8 leading-relaxed">
        Your 7-day trial has ended. Subscribe for <strong className="text-amber-400">$19/month</strong> to unlock Coach, Tools, Playbooks, Recovery, Date Planner & Weekly Check-In. Cancel anytime.
      </p>
      <div className="flex flex-wrap justify-center gap-3">
        <Link to="/upgrade" className="btn-amber inline-flex items-center gap-2" data-testid="paywall-upgrade">
          Subscribe <ArrowRight className="w-4 h-4" />
        </Link>
        <Link to="/upgrade" className="btn-ghost inline-flex items-center gap-2" data-testid="paywall-promo">
          <Key className="w-4 h-4" /> I have a code
        </Link>
      </div>
      <div className="mt-10 text-xs text-neutral-500 flex items-center justify-center gap-2">
        <Sparkles className="w-3 h-3 text-amber-500" /> Library remains free. Your saved articles are preserved.
      </div>
    </div>
  );
};

export default Paywall;
